module.exports = __webpack_public_path__ + "img/undraw_void_3ggu.c90c3ea3.svg";